import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';

const mockTransactions = [
  {
    id: 1,
    client: 'John Doe',
    type: 'deposit',
    amount: 1000,
    status: 'completed',
    date: '2024-03-20',
    reference: 'DEP-001',
  },
  {
    id: 2,
    client: 'Jane Smith',
    type: 'withdrawal',
    amount: 500,
    status: 'pending',
    date: '2024-03-19',
    reference: 'WIT-001',
  },
  {
    id: 3,
    client: 'Mike Johnson',
    type: 'commission',
    amount: 250,
    status: 'completed',
    date: '2024-03-18',
    reference: 'COM-001',
  },
];

export default function Transactions() {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'pending':
        return 'warning';
      case 'failed':
        return 'error';
      default:
        return 'default';
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'deposit':
        return 'primary';
      case 'withdrawal':
        return 'error';
      case 'commission':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Transaction History
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Reference</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockTransactions.map((transaction) => (
                <TableRow key={transaction.id}>
                  <TableCell>{transaction.reference}</TableCell>
                  <TableCell>{transaction.client}</TableCell>
                  <TableCell>
                    <Chip
                      label={transaction.type.toUpperCase()}
                      color={getTypeColor(transaction.type) as any}
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="right">
                    ${transaction.amount.toLocaleString()}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={transaction.status.toUpperCase()}
                      color={getStatusColor(transaction.status) as any}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{transaction.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
} 